import { RunStrategy } from "multitool-sdk-core";
const ui = {
    description: "Subtract two numbers!",
    defaultArgs: () => ({ a: 0, b: 0 }),
    strategies: () => [
        RunStrategy.INLINE,
        RunStrategy.SHARED_WORKER,
        RunStrategy.API,
    ],
    UISchema: {
        type: "VerticalLayout",
        elements: [
            {
                type: "HorizontalLayout",
                elements: [
                    {
                        type: "Control",
                        scope: "#/properties/a",
                        label: false,
                    },
                    {
                        type: "Label",
                        text: "-",
                    },
                    {
                        type: "Control",
                        scope: "#/properties/b",
                        label: false,
                    },
                ],
            },
        ],
    },
};
export default ui;
//# sourceMappingURL=ui.js.map

ui.ArgsSchema = 
{
  "$schema": "http://json-schema.org/draft-07/schema#",
  "additionalProperties": false,
  "definitions": {},
  "properties": {
    "a": {
      "maximum": 1.3,
      "type": "number"
    },
    "b": {
      "type": "number"
    }
  },
  "required": [
    "a",
    "b"
  ],
  "type": "object"
}
